module.exports = __webpack_public_path__ + "assets/f4ff59a003dbfcc4c2c005d3e6622497.png";